var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.showChart && _vm.chartdata)?_c('LineChart',{ref:"chart",staticClass:"column is-full",attrs:{"chart-data":_vm.chartdata,"options":_vm.chartoptions,"height":200}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }